import axios from 'axios';
import { IUIInfoResponse } from '../interfaces/registry';

export interface IRegistry {
  infoEndpoint: string;
  fetchUIInfo: () => Promise<IUIInfoResponse | null>;
}

export class Registry implements IRegistry {
  infoEndpoint: string;

  constructor(apiGateway: string) {
    if (!apiGateway) {
      apiGateway = 'https://api.kattana.trade';
    }
    this.infoEndpoint = `${apiGateway}/ui/v1/info`;
  }

  /**
   * Fetch UI info
   * @returns
   */
  public fetchUIInfo = async (): Promise<IUIInfoResponse | null> => {
    try {
      const res = await axios.get(this.infoEndpoint);
      return res.data;
    } catch (err) {
      console.warn(err);
      return null;
    }
  };
}
